/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface LngEntity
 */
export class LngEntity {
    /**
     *
     * @type {string}
     * @memberof LngEntity
     */
    code: string;
    /**
     *
     * @type {string}
     * @memberof LngEntity
     */
    display_name: string;
    /**
     *
     * @type {string}
     * @memberof LngEntity
     */
    full_name: string;
    /**
     *
     * @type {string}
     * @memberof LngEntity
     */
    dir: LngEntityDirEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum LngEntityDirEnum {
    Rtl = 'rtl',
    Ltr = 'ltr',
}
